import {ACTION_TYPE, getActionTypes} from 'Store/Shared/Actions/Helpers';
import ACTIONS from './ActionTypes';
import {SUBSTATUS} from 'Services/Status/Substatus.types';
import {NOTIFICATIONTYPE} from 'Store/Notification/ActionTypes';
import {VacancyId} from 'Store/Vacancy/PropTypes';
import {fetchVacancyV2} from 'Store/Vacancy/Actions';

export const fetchOfferOverviewByPagenumber = (
    overview_fields: string[],
    pageNumber: number = 1,
    filters: any = false,
    forceFetch: boolean = false
): ACTION_TYPE => {
    let flattenFilters = '';
    const filterKeys = Object.keys(filters);
    if (filterKeys) {
        for (const filterKey of filterKeys) {
            let values = filters[filterKey];
            if (Array.isArray(filters[filterKey])) {
                values = values.join(',');
            }
            flattenFilters += `&filter[${filterKey}]=${values}`;
        }
    }

    return {
        types: getActionTypes(ACTIONS.FETCH_OFFER_OVERVIEW_PAGE),
        shouldCallAPI: ({ vacancies }) => forceFetch || !vacancies._isFetchingPage.includes(pageNumber),
        callAPI: {
            url: `/api/v2/overview?entity=offer&page=${pageNumber}&overview_fields=${overview_fields ?? ''}${flattenFilters}`
        },
        payload: {
            page_number: pageNumber,
            isFiltering: flattenFilters.length > 0
        }
    }
}

export const createOffer = (data: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_OFFER),
    callAPI: {
        method: 'POST',
        url: '/api/v2/offers',
        body: data
    }
});

export const fetchOffer = (id: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_OFFER),
    callAPI: {
        url: `/api/v2.9/offers/${id}`
    }
});

export const fetchOfferConcept = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_OFFER_CONCEPT),
    callAPI: {
        url: `/api/v2.9/offers?substatus=${SUBSTATUS.ACTIVE.RECORD_CONCEPT}`
    }
});

export const fetchOfferValues = (id: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_OFFER_VALUES),
    callAPI: {
        url: `/api/v2/offers/${id}/values`,

    }
});

export const updateOffer = (id: any, data: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPDATE_OFFER),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/offers/${id}`,
        body: data
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
});

export const upsertOffer = (id: any, data: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPSERT_OFFER_VALUES),
    callAPI: {
        method: 'PUT',
        url: `/api/v2/offers/${id}/values`,
        body: data
    }
});

export const upsertOfferValues = (id: any, data: any) => ({
    types: getActionTypes(ACTIONS.UPSERT_OFFER_VALUES),
    callAPI: {
        method: 'PUT',
        url: `/api/v2/offers/${id}/values`,
        body: {
            values: data
        }
    }
})

export const updateOfferValues = (id: VacancyId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPDATE_OFFER_VALUES),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/offers/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
    callback: fetchVacancyV2(id)
})

export const deleteOffer = (id: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.DELETE_OFFER),
    callAPI: {
        method: 'DELETE',
        url: `/api/v2.9/offers/${id}`
    }
});